import React from "react";
import firebase from './components/Fireb';
import Login from './Login';
import App from './App'
import { Spinner } from 'react-spinners-css';
import { BrowserRouter as Router } from "react-router-dom";
import { ProductProvider } from "./context";

export default class Loading extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          user: null,
          animating: true
        };
      }
    componentDidMount() {
        firebase.auth().onAuthStateChanged(user => {
           if(user) {this.setState({user})};
           this.closeActivityIndicator();
        });
    }
    closeActivityIndicator(){
        setTimeout(() => {
            this.setState({animating: false});
    }, 1500)
    }

    render() {   
        return (
            <div>
                {this.state.animating ?
                           <Spinner color="#004e92" size={200} animating={this.state.animating} style={{marginTop: '370px', marginLeft: '810px'}}/>
                    : this.state.user ?
                    <ProductProvider>
    <Router>
      <App />
    </Router>
  </ProductProvider>
                  :
                  <Login/>}
             
  </div>
      
        );
    }
}